(function () {
    'use strict';

    angular
        .module('initiativeUpdateStatusReviewRoutes', [
            'businessPlanningModule',
            'services.pageDirty'
        ])
        .config(router);

    router.$inject = ['$stateProvider'];

    function router($stateProvider) {
        $stateProvider
            .state('initiativeUpdateStatusReview', {
                url: '/InitiativeUpdateStatus/Review/User@{ItemPersonID:int}',
                data: {
                    permissions: { featureRole: 'GRCInitiativeUpdateStatusManagement', key: 'PlanInitiative', permission: 'ReviewAssessment' }
                },
                resolve: {
                    govProcess: ['grcGovernanceProcessService', function (service) {
                        return service.getActiveInitiativeUpdateStatus();
                    }]
                },
                views: {
                    '': {
                        template: '<div ui-view="mainContent" class="initiative-update-status" autoscroll="true"></div>',
                        controller: 'InitiativeUpdateStatusReviewController'
                    }
                }
            })

            .state('initiativeUpdateStatusReview.noActiveProcess', {
                url: '/NoActiveProcess',
                views: {
                    'mainContent@initiativeUpdateStatusReview': {
                        templateUrl: require('./noActiveProcess.tpl.html'),
                    }
                }
            })

            .state('initiativeUpdateStatusReview.initiatives', {
                url: '/Initiative',
                abstract: true,
                resolve: {
                    initAssessmentsByAssessor: ['$stateParams', 'initiativeUpdateStatusService', function ($stateParams, service) {
                        return service.getInitiativeAssessmentsToReviewByAssessor($stateParams.ItemPersonID);
                    }]
                }
            })

            .state('initiativeUpdateStatusReview.initiatives.review', {
                views: {
                    'mainContent@initiativeUpdateStatusReview': {
                        controller: 'InitiativeUpdateStatusReviewInitiativesListController'
                    }
                },
                resolve: {
                    planLookups: ['businessPlanningService', function (service) {
                        return service.getPlanLookups();
                    }]
                }
            })

            .state('initiativeUpdateStatusReview.initiatives.review.byInitiative', {
                url: '/{PlanInitiativeID:int}',
                abstract: true
            })

            .state('initiativeUpdateStatusReview.initiatives.review.byInitiative.assessment', {
                url: '/Review',
                views: {
                    'mainContent@initiativeUpdateStatusReview': {
                        controller: 'InitiativeUpdateStatusReviewInitiativeController',
                        templateUrl: require('./reviewInitiativeAssessmentByInitiative.tpl.html'),
                        resolve: {
                            // Don't move to parent view to force reloading data from server upon navigation
                            assessmentByInitiative: ['$stateParams', 'initiativeUpdateStatusService', function ($stateParams, service) {
                                return service.getAssessmentsToReviewByAssessorAndInitiative($stateParams.ItemPersonID, $stateParams.PlanInitiativeID);
                            }],
                            fiscalYearQuarterKeys: ['assessmentByInitiative', function (assessmentByInitiative) {
                                // Group fiscal years by Quarter keys
                                return _.chain(assessmentByInitiative.PlanDeliverableAssessments)
                                    .map(function (delivAssess) {
                                        return delivAssess.MilestoneGroup.TargetFiscalYearAndQuarter;
                                    })
                                    .uniq()
                                    .value();
                            }]
                        }
                    }
                }
            })

            .state('initiativeUpdateStatusReview.initiatives.review.byInitiative.deliverables', {
                url: '/Deliverable/Review',
                views: {
                    'mainContent@initiativeUpdateStatusReview': {
                        controller: 'InitiativeUpdateStatusReviewDeliverablesByInitiativeController'
                    }
                },
                resolve: {
                    // Don't move to parent view to force reloading data from server upon navigation
                    assessmentByInitiative: ['$stateParams', 'initiativeUpdateStatusService', function ($stateParams, service) {
                        return service.getAssessmentsToReviewByAssessorAndInitiative($stateParams.ItemPersonID, $stateParams.PlanInitiativeID);
                    }],
                    fiscalYearQuarterKeys: ['assessmentByInitiative', function (assessmentByInitiative) {
                        // Group fiscal years by Quarter keys
                        return _.chain(assessmentByInitiative.PlanDeliverableAssessments)
                            .map(function (delivAssess) {
                                return delivAssess.MilestoneGroup.TargetFiscalYearAndQuarter;
                            })
                            .uniq()
                            .value();
                    }]
                }
            })

            .state('initiativeUpdateStatusReview.initiatives.review.byInitiative.noDeliverables', {
                url: '/Deliverable/Review',
                views: {
                    'mainContent@initiativeUpdateStatusReview': {
                        controller: 'InitiativeUpdateStatusReviewDeliverablesByInitiativeController',
                        templateUrl: require('./byInitiativeNoDeliverables.tpl.html')
                    }
                },
                resolve: {
                    assessmentByInitiative: ['$stateParams', 'initiativeUpdateStatusService', function ($stateParams, service) {
                        return service.getAssessmentsToReviewByAssessorAndInitiative($stateParams.ItemPersonID, $stateParams.PlanInitiativeID);
                    }],
                    fiscalYearQuarterKeys: [function () {
                        return [];
                    }]
                }
            })

            .state('initiativeUpdateStatusReview.initiatives.review.byInitiative.deliverablesByQuarter', {
                url: '/Deliverable/Review/Quarter/{FiscalYearQuarterKey}',
                params: {
                    toPrevious: { value: undefined },
                    toNext: { value: undefined }
                },
                data: {
                    permissions: { featureRole: 'GRCInitiativeUpdateStatusManagement', key: 'PlanInitiative', permission: 'ReviewAssessment' }
                },
                views: {
                    'mainContent@initiativeUpdateStatusReview': {
                        templateUrl: require('./deliverablesByQuarter.tpl.html'),
                        controller: 'InitiativeUpdateStatusReviewDeliverablesByQuarterController',
                        resolve: {
                            // Don't move to parent view to force reloading data from server upon navigation
                            assessmentByInitiative: ['$stateParams', 'initiativeUpdateStatusService', function ($stateParams, service) {
                                return service.getAssessmentsToReviewByAssessorAndInitiative($stateParams.ItemPersonID, $stateParams.PlanInitiativeID);
                            }],
                            fiscalYearQuarterKeys: ['assessmentByInitiative', function (assessmentByInitiative) {
                                // Group fiscal years by Quarter keys
                                return _.chain(assessmentByInitiative.PlanDeliverableAssessments)
                                    .map(function (delivAssess) {
                                        return delivAssess.MilestoneGroup.TargetFiscalYearAndQuarter;
                                    })
                                    .uniq()
                                    .value();
                            }],
                            deliverableAssessmentsByQuarter: ['$stateParams', 'assessmentByInitiative', function ($stateParams, assessmentByInitiative) {
                                return _.filter(assessmentByInitiative.PlanDeliverableAssessments, {
                                    MilestoneGroup: {TargetFiscalYearAndQuarter: $stateParams.FiscalYearQuarterKey}
                                });
                            }]
                        }
                    }
                }
            });
    }
})();
